import { ArrowRight, Lock, MessageCircle } from 'lucide-react';

const PreActivation = ({ onActivate }) => {
  const handleWhatsApp = () => {
    const message = 'Hi, I need help to activate my GG DESK account.';
    const waLink = `https://wa.me/6281234567890?text=${encodeURIComponent(message)}`;
    window.open(waLink, '_blank');
  };

  return (
    <div className="pre-activation">
      <div className="pre-activation-card animate-fade-in">
        <img
          src="https://customer-assets.emergentagent.com/job_ringgit-trade-hub/artifacts/31oc9nj4_IMG_0100.jpeg"
          alt="GG DESK Logo"
          className="pre-activation-logo"
          style={{ borderRadius: '50%', border: '3px solid #8B1538' }}
        />
        
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          gap: '8px',
          marginBottom: '16px'
        }}>
          <Lock size={24} style={{ color: '#8B1538' }} />
          <h1 className="pre-activation-title" style={{ margin: 0 }}>
            ACCESS NOT ACTIVATED
          </h1>
        </div>
        
        <p className="pre-activation-text">
          GG DESK tools akan aktif selepas trading account anda verified dengan broker partner.
        </p>

        <div style={{ 
          background: 'var(--bg-secondary)', 
          padding: '20px', 
          marginBottom: '24px',
          border: '1px solid var(--border-subtle)',
          borderRadius: '8px'
        }}>
          <div style={{ fontSize: '14px', color: 'var(--text-muted)', marginBottom: '12px' }}>
            Activation Steps:
          </div>
          <ol style={{ 
            textAlign: 'left', 
            fontSize: '14px', 
            color: 'var(--text-secondary)', 
            lineHeight: '1.8',
            paddingLeft: '20px',
            margin: 0
          }}>
            <li>Register broker via IB link</li>
            <li>Verify your trading account</li>
            <li>Confirm dengan IB partner</li>
          </ol>
        </div>

        <button 
          className="btn-pink animate-pulse-pink" 
          style={{ width: '100%', marginBottom: '16px', borderRadius: '8px' }}
          onClick={onActivate}
        >
          Register Broker & Activate
          <ArrowRight size={18} />
        </button>

        <button 
          className="btn-secondary" 
          style={{ width: '100%' }}
          onClick={handleWhatsApp}
        >
          <MessageCircle size={18} />
          Need Help?
        </button>

        <p style={{ 
          fontSize: '12px', 
          color: 'var(--text-muted)', 
          marginTop: '24px',
          lineHeight: '1.6'
        }}>
          "This is not a get-rich-quick tool.<br />This is for serious traders only."
        </p>
      </div>
    </div>
  );
};

export default PreActivation;
